import { Controller } from 'stimulus';
import { gsap } from 'gsap';

export default class extends Controller { 
  static targets = [ 'text', 'close' ];

  connect() {
    this.waiting = true;
    this.animation = gsap.timeline({
        paused: true,
        defaults: {
          duration: .1,
          ease: 'none',
        }
      })
      .addLabel('start')
      .to(this.textTarget, {
        duration: 0,
        autoAlpha: 0,
      }, 'start')
      .to(this.closeTarget, {
        autoAlpha: 1,
        rotateZ: '0deg',
      }, 'start'); 
    
    gsap.to(this.closeTarget, {
      duration: 0,
      autoAlpha: 0,
      rotateZ: '80deg',
    })
  } 

  animate() { 
    this.waiting ? this.animation.play() : this.animation.reverse();
    this.waiting = !this.waiting;
  }

  open() {
    this.animation.play();
    this.waiting = false;
  }

  close() {
    this.animation.reverse();
    this.waiting = false;
  }
}